import { useNavigate } from "react-router-dom";
import { useApp } from "../contexts/AppContext";
import LogoSVG from "../components/LogoSVG";
import WaveBottom from "../components/WaveBottom";
import PostCard from "../components/PostCard";
import { ORG, byDateDesc } from "../data/initialData";

export default function HomePage() {
  const { posts, about } = useApp();
  const navigate = useNavigate();

  const latestThree = [...posts]
    .filter(p => p.published)
    .sort(byDateDesc)
    .slice(0, 3);

  return (
    <div>
      <section className="hero">
        <div className="hero-content fade-up">
          <div className="hero-logo-ring"><LogoSVG size={92} inv/></div>
          <div className="hero-inc">Inc. No. {ORG.incNo} — Associations Incorporation Act 2023</div>
          <h1>Lomban Hydropower<br/><em>Development Association</em></h1>
          <div className="hero-sub">Wabag District · Enga Province · Papua New Guinea</div>
          <p>Representing the customary landowners of Lomban Falls on the Lai River — the <strong>Kaiyaul</strong> and <strong>Piau</strong> clans — in the development of clean, community-owned hydroelectric power.</p>
          <div className="hero-btns">
            <button className="h-b1" onClick={() => navigate("/about")}>About LHDA</button>
            <button className="h-b2" onClick={() => navigate("/projects")}>Our Projects</button>
          </div>
        </div>
        <WaveBottom/>
      </section>

      <div className="badge-bar">
        {[
          { ic:"📋", lbl:"Incorporation No.", val: ORG.incNo },
          { ic:"📍", lbl:"Location",          val: "Wabag, Enga Province, PNG" },
          { ic:"📅", lbl:"Founded",           val: ORG.foundingDate },
          { ic:"👥", lbl:"Founding Members",  val: "48 Family Representatives" },
          { ic:"⚡", lbl:"Trustee Company",   val: "Lomban Hydropower Limited" },
        ].map((b, i) => (
          <div key={i} className="badge">
            <div className="badge-ic">{b.ic}</div>
            <div><div className="badge-lbl">{b.lbl}</div><div className="badge-val">{b.val}</div></div>
          </div>
        ))}
      </div>

      <section className="sec sec-alt">
        <div className="container">
          <div className="sec-hdr">
            <div className="eyebrow">Who We Are</div>
            <h2>Mission &amp; Vision</h2>
            <p>Guided by the principles of community ownership, transparent governance, and sustainable development.</p>
          </div>
          <div className="grid2">
            <div className="mv-g"><div className="mv-icon">🎯</div><div className="mv-title">Our Mission</div><p className="mv-text">{about.mission}</p></div>
            <div className="mv-b"><div className="mv-icon">🔭</div><div className="mv-title">Our Vision</div><p className="mv-text">{about.vision}</p></div>
          </div>
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <button className="btn-g" onClick={() => navigate("/about")}>Learn More About LHDA →</button>
          </div>
        </div>
      </section>

      <section className="sec">
        <div className="container">
          <div className="sec-hdr">
            <div className="eyebrow">News &amp; Announcements</div>
            <h2>Latest Updates</h2>
            <p>Stay informed about LHDA's activities, project milestones, and community developments.</p>
          </div>
          <div className="grid3">
            {latestThree.map(post => <PostCard key={post.id} post={post}/>)}
          </div>
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <button className="btn-b" onClick={() => navigate("/news")}>All News &amp; Announcements →</button>
          </div>
        </div>
      </section>

      <section className="sec sec-alt">
        <div className="container">
          <div className="sec-hdr">
            <div className="eyebrow">Our Work</div>
            <h2>Key Projects &amp; Initiatives</h2>
            <p>From land registration to hydropower development, LHDA advances multiple parallel initiatives for the benefit of all landowners.</p>
          </div>
          <div style={{ textAlign: "center" }}>
            <button className="btn-g" onClick={() => navigate("/projects")}>View All Projects →</button>
          </div>
        </div>
      </section>
    </div>
  );
}
